// PR 53 fixes · sub-agent Q — F2 (WARNING status on the validation screen), F8 (redirect a line of the linked current-year
// entry), F9 (clear / un-clear a FLAG), EN + AR. Merged into lib/i18n.js translations (big-file rule).
export const I18N_B34Q = {
  en: {
    ifrs: { validation: { status: { WARNING: "WARNING" } } },
    b34q: {
      clear: "Clear",
      unclear: "Un-clear",
      clearTitle: "Clear the flag",
      clearHint: "A cleared flag counts as passed (all checks passed, publication). It shows again if the amount changes.",
      reason: "Reason",
      confirmClear: "Clear the flag",
      confirmUnclear: "Un-clear",
      cleared: "Flag cleared.",
      uncleared: "Flag shown again.",
      clearedBy: "Cleared by {name} on {date}",
      linkedTitle: "Linked current-year entry {ref}",
      redirect: "Redirect account",
      redirectTitle: "Redirect line {n} to another account",
      redirectHint: "The line stays on the same side of the statement of financial position (assets or liabilities); the amount does not change.",
      account: "Account",
      redirectConfirm: "Redirect",
      redirected: "Account redirected.",
      redirectedFrom: "planned on {code} · {reason}",
      cancel: "Cancel",
    },
    errors: {
      RESTATEMENT_REDIRECT_REASON: "Give the reason for redirecting the account.",
      RESTATEMENT_REDIRECT_LINE: "That line is not on the linked current-year entry.",
      RESTATEMENT_REDIRECT_NOT_BS: "Only an asset or liability line can be redirected.",
      RESTATEMENT_REDIRECT_UNKNOWN_ACCOUNT: "That account is not on this engagement's chart of accounts.",
      RESTATEMENT_REDIRECT_SIDE: "The line must stay on the same side of the statement of financial position (assets or liabilities).",
      RESTATEMENT_REDIRECT_SAME: "The line is already on that account.",
      RESTATEMENT_REDIRECT_NOT_A: "Only the linked current-year entry of a posted treatment (a) entry can be redirected.",
      RESTATEMENT_FLAG_ROLE: "Only a Reviewer, a Supervisor, a Manager (Assistant, Senior or Audit Manager), a Director, a Partner or the Firm Admin may clear or un-clear a flag.",   // Batch 35 · P53-R3
      RESTATEMENT_FLAG_REASON: "Give the reason for clearing the flag.",
      RESTATEMENT_FLAG_NOT_SHOWN: "This flag is not shown on the statements now — nothing to clear.",
      RESTATEMENT_FLAG_NOT_CLEARED: "This flag is not cleared.",
    },
  },
  ar: {
    ifrs: { validation: { status: { WARNING: "تنبيه" } } },
    b34q: {
      clear: "إغلاق",
      unclear: "إعادة فتح",
      clearTitle: "إغلاق التنبيه",
      clearHint: "يُحتسب التنبيه المُغلق ناجحًا (نجاح جميع الفحوصات، والنشر). ويظهر مجددًا إذا تغيّر المبلغ.",
      reason: "السبب",
      confirmClear: "إغلاق التنبيه",
      confirmUnclear: "إعادة فتح",
      cleared: "أُغلق التنبيه.",
      uncleared: "ظهر التنبيه مجددًا.",
      clearedBy: "أُغلق بواسطة {name} في {date}",
      linkedTitle: "القيد المرتبط للسنة الحالية {ref}",
      redirect: "تغيير الحساب",
      redirectTitle: "تغيير حساب السطر {n}",
      redirectHint: "يبقى السطر في الجانب نفسه من قائمة المركز المالي (الأصول أو الالتزامات)؛ ولا يتغيّر المبلغ.",
      account: "الحساب",
      redirectConfirm: "تغيير",
      redirected: "تم تغيير الحساب.",
      redirectedFrom: "مخطط على {code} · {reason}",
      cancel: "إلغاء",
    },
    errors: {
      RESTATEMENT_REDIRECT_REASON: "اذكر سبب تغيير الحساب.",
      RESTATEMENT_REDIRECT_LINE: "هذا السطر غير موجود في القيد المرتبط للسنة الحالية.",
      RESTATEMENT_REDIRECT_NOT_BS: "لا يمكن تغيير الحساب إلا لسطر أصل أو التزام.",
      RESTATEMENT_REDIRECT_UNKNOWN_ACCOUNT: "هذا الحساب غير موجود في دليل حسابات هذا الارتباط.",
      RESTATEMENT_REDIRECT_SIDE: "يجب أن يبقى السطر في الجانب نفسه من قائمة المركز المالي (الأصول أو الالتزامات).",
      RESTATEMENT_REDIRECT_SAME: "السطر مسجّل بالفعل على هذا الحساب.",
      RESTATEMENT_REDIRECT_NOT_A: "لا يمكن تغيير الحساب إلا في القيد المرتبط للسنة الحالية لقيد مرحّل بالمعالجة (أ).",
      RESTATEMENT_FLAG_ROLE: "لا يُغلق التنبيه أو يُعيد فتحه إلا المراجع أو المشرف أو المدير (مساعد المدير أو المدير الأول أو مدير المراجعة) أو المدير التنفيذي أو الشريك أو مسؤول الشركة.",
      RESTATEMENT_FLAG_REASON: "اذكر سبب إغلاق التنبيه.",
      RESTATEMENT_FLAG_NOT_SHOWN: "هذا التنبيه غير ظاهر في القوائم الآن — لا يوجد ما يُغلق.",
      RESTATEMENT_FLAG_NOT_CLEARED: "هذا التنبيه غير مُغلق.",
    },
  },
};

export default I18N_B34Q;
